import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
} from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  inpObj: {
    type: Object,
    default: function () {
      return {
        inpValue: "", // 输入框值
        inputType: "text", // 输入框类型
        autoFocus: true, // 是否自动聚焦
      };
    },
  },
  placeholder: {
    type: String,
    default: "Enter email",
  },
},
  emits: ["inpObj"],
  setup(__props, { emit }) {

const prop = __props

// const imgUrl= require("@/assets/images/alexa/ic_16_close@3x.png");
const inputs = ref();
onMounted(() => {
  // 输入框自动聚焦，但在IOS下不能生效（ios为了保护安全，禁止自动获取输入框focus方法）
  // 参考：https://blog.csdn.net/weixin_42437043/article/details/105250966
  if (!state.normalInputObj.autoFocus) return;
  inputs.value.focus();
});


const state = reactive({
  normalInputObj: prop.inpObj,
  imgUrl: require("@/assets/images/alexa/ic_16_close@3x.png"),
});
const { normalInputObj, imgUrl } = toRefs(state);
const changeInp = (val: string) => {
  state.normalInputObj.inpValue = val;
  emit("inpObj", state.normalInputObj);
};
const optIconFn = () => {
  state.normalInputObj.inpValue = "";
  emit("inpObj", state.normalInputObj.inpValue);
};
const clearable = computed(() => {
  const { inpValue } = state.normalInputObj;
  return inpValue?.length !== 0;
});
const dir = document.dir;

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    class: "email-inp",
    modelValue: _unref(normalInputObj).inpValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(normalInputObj).inpValue) = $event)),
    type: __props.inpObj.inputType,
    placeholder: __props.placeholder,
    maxlength: 320,
    ref_key: "inputs",
    ref: inputs,
    onInput: changeInp
  }, _createSlots({ _: 2 }, [
    (_unref(dir) === 'rtl')
      ? {
          name: "prefix",
          fn: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_image, {
              class: "el-img",
              onClick: optIconFn,
              src: _unref(imgUrl)
            }, null, 8, ["src"]), [
              [_vShow, _unref(clearable)]
            ])
          ])
        }
      : undefined,
    (_unref(dir) !== 'rtl')
      ? {
          name: "suffix",
          fn: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_image, {
              class: "el-img",
              onClick: optIconFn,
              src: _unref(imgUrl)
            }, null, 8, ["src"]), [
              [_vShow, _unref(clearable)]
            ])
          ])
        }
      : undefined
  ]), 1032, ["modelValue", "type", "placeholder"]))
}
}

})